/**
 * DKM-5193 Cedric: Destek talebi için ekran görüntüsü (Helpdesk Faz 2).
 *
 * Yalnız kullanıcı "Ekran görüntüsü ekle"yi seçtiğinde çağrılır (otomatik çekim yok).
 * html2canvas-pro tembel yüklenir (`await import`) — ana pakete girmez, ilk kullanımda ayrı parça olarak iner.
 * (html2canvas 1.4.1 değil: temadaki modern CSS renk işlevlerinde — color(), color-mix — "unsupported color function"
 * hatasıyla düşüyordu; html2canvas-pro aynı API'li, bakımı süren MIT çatalı.)
 * Görüntüye yalnız tarayıcıdaki görünür alan girer; `haric` öğesi (destek penceresinin kendisi) ve bildirimler
 * (toastr) çizilmez. Sonuç JPEG (kalite 0.7, en çok 1920 px genişlik) data URL'dir.
 */

const AZAMI_GENISLIK = 1920;
const JPEG_KALITE = 0.7;

/** Görüntüye girmeyecek öğeler: destek penceresi (verilen kök) ve bildirim kutuları. */
export function ekranGoruntusuHaricMi(el: Element, haric: Element | null): boolean {
  try {
    if (haric && el === haric) return true;
    const id = (el as HTMLElement).id;
    if (id === 'toast-container') return true;
    return false;
  } catch {
    return false;
  }
}

/** Tuval çok genişse orantılı küçültür (aynı tuvali ya da yenisini döndürür). */
export function tuvalKucult(tuval: HTMLCanvasElement, azami = AZAMI_GENISLIK): HTMLCanvasElement {
  if (!tuval || tuval.width <= azami) return tuval;
  const oran = azami / tuval.width;
  const yeni = document.createElement('canvas');
  yeni.width = azami;
  yeni.height = Math.max(1, Math.round(tuval.height * oran));
  const ctx = yeni.getContext('2d');
  if (!ctx) return tuval;
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, yeni.width, yeni.height);
  ctx.drawImage(tuval, 0, 0, yeni.width, yeni.height);
  return yeni;
}

/**
 * Görünür ekranın görüntüsünü alır. `haric`: görüntüye girmeyecek kök öğe (destek penceresinin overlay sarmalayıcısı).
 * Hata olursa fırlatır — çağıran yakalayıp kullanıcıya "alınamadı" der, talep görüntüsüz gönderilebilir.
 */
export async function ekranGoruntusuAl(haric: Element | null): Promise<string> {
  const mod: any = await import('html2canvas-pro');
  const html2canvas = mod.default || mod.html2canvas || mod;
  const tuval: HTMLCanvasElement = await html2canvas(document.body, {
    x: window.scrollX,
    y: window.scrollY,
    width: window.innerWidth,
    height: window.innerHeight,
    windowWidth: document.documentElement.clientWidth,
    windowHeight: document.documentElement.clientHeight,
    scale: 1,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    ignoreElements: (el: Element) => ekranGoruntusuHaricMi(el, haric),
  });
  return tuvalKucult(tuval).toDataURL('image/jpeg', JPEG_KALITE);
}

/** data URL'nin yaklaşık bayt boyutu (base64 → ikili). */
export function dataUrlBoyut(dataUrl: string | null | undefined): number {
  if (!dataUrl) return 0;
  const virgul = dataUrl.indexOf(',');
  const b64 = virgul >= 0 ? dataUrl.slice(virgul + 1) : dataUrl;
  const dolgu = b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0;
  return Math.max(0, Math.floor((b64.length * 3) / 4) - dolgu);
}
